// import room1 from "./images/details-1.jpeg";
import room2 from "./images/item1.jpg"; //will be changed later
import room3 from "./images/item2.jpg"; //will be changed later
import room4 from "./images/item3.jpg"; //will be changed later
import img1 from "./images/item1.jpg";
import img2 from "./images/item2.jpg";
import img3 from "./images/item3.jpg";
import img4 from "./images/item4.jpg";
import img5 from "./images/item5.jpg";
import img6 from "./images/item6.jpg";
import img7 from "./images/item7.jpg";
import img8 from "./images/item8.jpg";
import img9 from "./images/item9.jpg";
import img10 from "./images/item10.jpg";
import img11 from "./images/81V7L6auixL._SL1500_.jpg";
import adventureimg1 from "./images/712+GkpF-wL._SL1500_.jpg";
import adventureimg2 from "./images/71BTSl5sfwL._SL1500_.jpg";
import adventureimg3 from "./images/71xMjwoZLaL._SL1500_.jpg";
import adventureimg4 from "./images/71ODe8urfGL._SL1500_.jpg";
import img12 from "./images/81+4Spiow3L._SL1500_.jpg";
import marioImg1 from "./images/81zyRwwNYrL._SL1500_.jpg";
import marioImg2 from "./images/71ZZud1ZecL._SL1500_.jpg";
import marioImg3 from "./images/71hMnIk21hL._SL1500_.jpg";
import marioImg4 from "./images/81sqCTTNquL._SL1500_.jpg";
import img13 from "./images/71p5GSQ-BVL._AC_SL1500_.jpg";
import cosoriImg1 from "./images/91wB6V1OBEL._AC_SL1500_.jpg";
import cosoriImg2 from "./images/71R3oboi-EL._AC_SL1500_.jpg";
import cosoriImg3 from "./images/71hayS2aIfL._AC_SL1500_.jpg";
import cosoriImg4 from "./images/91tE2IOWncL._AC_SL1500_.jpg";
import img14 from "./images/91B8LqEiEyL._AC_SL1500_.jpg";
import rubbermaidImg1 from "./images/91QpSusdj1L._AC_SL1500_.jpg";
import rubbermaidImg2 from "./images/91LNaF-ADOL._AC_SL1500_.jpg";
import rubbermaidImg3 from "./images/81oUSXkh+TL._AC_SL1500_.jpg";
import rubbermaidImg4 from "./images/71+AZqKge3L._AC_SL1500_.jpg";
import img15 from "./images/81-f3EpuvGL._AC_SL1500_.jpg";
import vitmixImg1 from "./images/81eSiTPr5IL._AC_SL1500_.jpg";
import vitmixImg2 from "./images/81lsyvNemKL._AC_SL1500_.jpg";
import vitmixImg3 from "./images/71+90DCooAL._AC_SL1500_.jpg";
import vitmixImg4 from "./images/71Ir0ifwH+L._AC_SL1500_.jpg";
import img16 from "./images/71pC69I3lzL._AC_SL1500_.jpg";
import macImg1 from "./images/81aot0jAfFL._AC_SL1500_.jpg";
import macImg2 from "./images/91GRfDGDJIL._AC_SL1500_.jpg";
import macImg3 from "./images/91GsCwayBPL._AC_SL1500_.jpg";
import macImg4 from "./images/81mJ-Mdc-OL._AC_SL1500_.jpg";
import img17 from "./images/71VjM5LOeYL._AC_UX569_.jpg";
import bidenImg1 from "./images/81AtD3TZ2rL._AC_UX569_.jpg";
import bidenImg2 from "./images/81v70ksZn0L._AC_UX569_.jpg";
import bidenImg3 from "./images/81oopJz9BJL._AC_UX569_.jpg";
import bidenImg4 from "./images/81Vflp-UswL._AC_UX569_.jpg";
import img18 from "./images/81ZKNYBwYlL._AC_SL1500_.jpg";
import samWatchImg1 from "./images/81vW0jAzVfL._AC_SL1500_.jpg";
import samWatchImg2 from "./images/81MCD0w9RNL._AC_SL1500_.jpg";
import samWatchImg3 from "./images/71P0C5P3iDL._AC_SL1500_.jpg";
import samWatchImg4 from "./images/611EsK7rWIL._AC_SL1000_.jpg";
import img19 from "./images/81MmoQHsq4L._AC_UY606_.jpg";
import fossilImg1 from "./images/71-vMzevFhL._AC_UX466_.jpg";
import fossilImg2 from "./images/71CVy+LfHEL._AC_UX569_.jpg";
import fossilImg3 from "./images/81c7nyvI0hL._AC_UX569_.jpg";
import fossilImg4 from "./images/91WzO6167wL._AC_UX679_.jpg";
import img20 from "./images/81gU8AZ4WaL._AC_UX569_.jpg";
import korsImg1 from "./images/71xMYOXUj7L._AC_UX569_.jpg";
import korsImg2 from "./images/81vumDv6LAL._AC_UX569_.jpg";
import korsImg3 from "./images/81VP7IGGLbL._AC_UX679_.jpg";
import korsImg4 from "./images/71buNyy1tIL._AC_UX679_.jpg";
import img21 from "./images/71nULqACDeL._AC_SY550._SX._UX._SY._UY_.jpg";
import nixonImg1 from "./images/71UfrK9BwbL._AC_SY550._SX._UX._SY._UY_.jpg";
import nixonImg2 from "./images/81YHHLKNT7L._AC_SY550._SX._UX._SY._UY_.jpg";
import nixonImg3 from "./images/812rpLDPfeL._AC_SX466._SX._UX._SY._UY_.jpg";
import nixonImg4 from "./images/613gqDQIT0L._AC_SX679._SX._UX._SY._UY_.jpg";
import img22 from "./images/51SFK0A66YL._AC_UX569_.jpg";
import besImg1 from "./images/71jA148ePCL._AC_UX569_.jpg";
import besImg2 from "./images/511G+1NOgQL._AC_UX569_.jpg";
import besImg3 from "./images/61C3dzUaVPL._AC_UX569_.jpg";
import besImg4 from "./images/61D9VRkjPWL._AC_UX569_.jpg";
import img23 from "./images/81qpl4OcVLL._AC_UY606_.jpg";
import fossil2Img1 from "./images/81Jm29eV+SL._AC_UX679_.jpg";
import fossil2Img2 from "./images/61QTs18YRcL._AC_UX679_.jpg";
import fossil2Img3 from "./images/91aK3jyU-bL._AC_UX569_.jpg";
import fossil2Img4 from "./images/61ddl6gL6cL._AC_UX679_.jpg";
import magmaImg1 from "./images/61Na4U9J8+L._SL1500_.jpg";
import magmaImg2 from "./images/71U7CvkhFuL._SL1500_.jpg";
import magmaImg3 from "./images/81P9dXpJbDL._SL1500_.jpg";
import magmaImg4 from "./images/71U7CvkhFuL._SL1500_.jpg";
import img24 from "./images/71F6eID-ImL._SL1500_.jpg";
import eliteImg1 from "./images/71wuT1b72QL._SL1500_.jpg";
import eliteImg2 from "./images/71vHUG-oPOL._SL1500_.jpg";
import eliteImg3 from "./images/71I2mUnn0AL._SL1500_.jpg";
import eliteImg4 from "./images/61KNonXoVYL._SL1200_.jpg";
import img25 from "./images/81+BptkOmnL._SL1500_.jpg";
import turtleImg1 from "./images/814PVmS7JyL._SL1500_.jpg";
import turtleImg2 from "./images/71wkJ5I657L._SL1500_.jpg";
import turtleImg3 from "./images/81BNgBLT1vL._SL1500_.jpg";
import turtleImg4 from "./images/81Dx4Nx5dTL._SL1500_.jpg";
import img26 from "./images/81Bzm37TIaL._SL1500_.jpg";
import ghostImg1 from "./images/712b2GBuVfL._SL1500_.jpg";
import ghostImg2 from "./images/71Pes5DjX2L._SL1500_.jpg";
import ghostImg3 from "./images/71AOiTcCc4L._SL1500_.jpg";
import ghostImg4 from "./images/81R7aZq7SfL._SL1500_.jpg";
import img27 from "./images/61s90CJzEzL._SL1200_.jpg";
import xboxImg1 from "./images/61ydQvFmtyL._SL1200_.jpg";
import xboxImg2 from "./images/617AFly6phL._SL1200_.jpg";
import xboxImg3 from "./images/61J+tfh433L._SL1200_.jpg";
import xboxImg4 from "./images/61KDlr8BRvL._SL1200_.jpg";
import img28 from "./images/71s1LRpaprL._AC_SL1500_.jpg";
import acerImg1 from "./images/71JK4qmCGyL._AC_SL1500_.jpg";
import acerImg2 from "./images/71sRKFnH1VL._AC_SL1500_.jpg";
import acerImg3 from "./images/71eQFOlZUtL._AC_SL1500_.jpg";
import acerImg4 from "./images/61OxWYGrH8L._AC_SL1500_.jpg";
import dashImg1 from "./images/81QKtaD1vSL._AC_SL1500_.jpg";
import dashImg2 from "./images/81zkybKpLBL._AC_SL1500_.jpg";
import dashImg3 from "./images/81OLHPnUi3L._AC_SL1500_.jpg";
import dashImg4 from "./images/81VPz2vLzrL._AC_SL1500_.jpg";
import img29 from "./images/71fis7dVn8L._AC_SL1500_.jpg";
import longhiImg1 from "./images/71UmaqAp8eL._AC_SL1500_.jpg";
import longhiImg2 from "./images/61pEEi55aKL._AC_SL1200_.jpg";
import longhiImg3 from "./images/813FGHSdITL._AC_SL1500_.jpg";
import longhiImg4 from "./images/51jsr4a+4LL._AC_SL1001_.jpg";

export default [   //ADD FREE SHIPPING "shippingCost: 0" AND MANUFATURING COMPANIES'S NAMES
  {
    sys: {
      id: "190ewb0fpf",
    },
    fields: {
      name: "HUAWEI MatePad Pro 10.8-inch 2K FullView Tablet - HUAWEI Kirin 990, 6 GB RAM, 128 GB ROM, Multi-screen Collaboration, EMUI 10.0.1 (Based Android 10.0), Wi-Fi, Midnight Grey",
      slug: "single-economy",
      type: "tech",
      price: 499,
      rating:5,
      discount:700,
      shippingCost:120,
      bestSeller: false,
      reviewsCount:"41,90",
      featured: false,
      subArray: "tech",
      quantity: 1,
      description:
        "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
      extras: [
        "Plush pillows and breathable bed linens",
        "Soft, oversized bath towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
      platform:"HUAWEI",
      liked: false,
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img1
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "2up9bfsr"
    },
    fields: {
      name: "USB C Cable, JSAUX (2m 2-Pack) Type C Fast Charger Charging Cable Braided Compatible for Samsung Galaxy S10 S9 S8 S20 Plus A3 A5 2017 Note 10 9 8, Huawei P10 P9, Google Pixel, Sony Xperia XZ, LG -Red",
      slug: "single-basic",
      type: "tech",
      price: 6.99,
      reviewsCount:"12,60",
      rating:4,
      bestSeller: false,
      discount:0,
      shippingCost:5,
      featured: false,
      subArray: "tech",
      quantity: 1,
      description:
        "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
      extras: [
        "Plush pillows and breathable bed linens",
        "Soft, oversized bath towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
      platform:"Samsung",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img2
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "3fspnu00wf"
    },
    fields: {
      name: "WiFi enabled Complete set of Dell OptiPlex Dual Core Windows 10 Desktop PC Computer",
      slug: "single-standard",
      type: "tech",
      price: 85,
      discount: 100,
      shippingCost:8,
      reviewsCount:"8,63",
      rating:2,
      bestSeller: true,
      subArray: "tech",
      featured: false,
      quantity: 1,
      description:
        "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
      extras: [
        "Plush pillows and breathable bed linens",
        "Soft, oversized bath towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
      platform:"Dell",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "4foposas"
    },
    fields: {
      name: "Sonos One SL - The Powerful Microphone-Free Speaker for Music and more, Black",
      slug: "single-deluxe",
      type: "tech",
      price: 169,
      rating:1,
      reviewsCount:"2,10",
      subArray: "tech",
      discount:0,
      shippingCost:60,
      bestSeller: true,
      featured: false,
      quantity: 1,
      description:
        "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
      extras: [
        "Plush pillows and breathable bed linens",
        "Soft, oversized bath towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
      platform:"Sonos",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img4
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "5fopwgwjf0"
    },
    fields: {
      name: "ELEPHAS Projector, GC333 Portable Projector with 4500 Lumens and Full HD 1080p, 180” Display and 50000 Hours Lamp Life LED Video Projector",
      slug: "double-economy",
      type: "tech",
      price: 29,
      reviewsCount:"22,18",
      rating:2,
      subArray: "tech",
      bestSeller: false,
      discount:0,
      shippingCost:14,
      featured: false,
      quantity: 1,
      description:
        "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
      extras: [
        "Plush pillows and breathable bed linens",
        "Soft, oversized bath towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
      platform:"Elephas",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img5
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "6a9wfb0f"
    },
    fields: {
      name: "Google Chromecast Smart TV Streaming Stick",
      slug: "double-basic",
      type: "tech",
      price: 3.99,
      rating:5,
      bestSeller: false,
      reviewsCount:"6,40",
      subArray: "tech",
      discount:0,
      shippingCost:5,
      featured: false,
      quantity: 1,
      description:
        "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
      extras: [
        "Plush pillows and breathable bed linens",
        "Soft, oversized bath towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
      platform:"Google",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img6
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "7fwwghtew"
    },
    fields: {
      name: "Samsung 50' TU8000 HDR Smart 4K TV with Tizen OS [Energy Class A]",
      slug: "samsung-tv",
      type: "tech",
      price: 450,
      rating:5,
      bestSeller: true,
      subArray: "tech",
      shippingCost:142,
      reviewsCount:"21,60",
      discount:729,
      featured: false,
      quantity: 1,
      description:
        "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
      extras: [
        "Plush pillows and breathable bed linens",
        "Soft, oversized bath towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
      platform:"Samsung",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img7
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "8fwapsqie"
    },
    fields: {
      name: "Dash Mini Maker: The Mini Waffle Maker Machine for Individual Waffles, Paninis, Hash browns, & other on the go Breakfast, Lunch, or Snacks - Red",
      slug: "dash-mini-maker",
      type: "kitchen",
      price: 9.99,
      discount: 14.99,
      rating:3,
      shippingCost:6,
      bestSeller: true,
      subArray: "kitchen",
      reviewsCount:"33,36",
      featured: true,
      quantity: 1,
      description:
        `details`,
      extras: [
        "MORE THAN WAFFLES: Make paninis, hash browns, and even biscuit pizzas! Any wet batter will “waffle” your treats and snacks into single serving portions. Great for kids or on the go",
        "COMPACT + LIGHTWEIGHT: Weighing 1lb+, this is a MUST-HAVE for that first apartment, smaller kitchen, college dorm life, or camper/RV traveling",
        "QUICK + EASY: Simply plug it in and go; it heats up in mere minutes. The dual non-stick surfaces provide an even cook for consistent results, each and every time. 4 inch cooking surfaces for individual portions",
        "PERFECT GIFT: The perfect wedding or new home gift. Its small size takes up little counter space, and its sleek design and trendy color options will match any kitchen décor. add to your registry now",
        "INCLUDES: Backed by a 1-year manufacturer warranty, the Dash Mini Waffle maker includes recipe book and recipe database access all non-electric parts are easily wiped clean",
        "U.S. BASED SUPPORT: Dash is a U.S. based company who provides contact information in each product manual",
      ],
      platform:"Dash",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img8
            }
          }
        },
        {
          fields: {
            file: {
              url: dashImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: dashImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: dashImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: dashImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "9wbweupe"
    },
    fields: {
      name: `Thermos Funtainer Food Jar, Frozen, 10 Ounce (Pack of 1)`,
      slug: "thermos-vacuum",
      type: "kitchen",
      price: 22.92,
      discount:0,
      bestSeller: false,
      subArray: "kitchen",
      rating:3,
      shippingCost:17,
      reviewsCount:"45,13",
      featured: false,
      quantity: 1,
      description:
            `THERMOS vacuum insulation technology for maximum temperature retention, hot or cold
            Durable stainless steel interior and exterior
            Wide mouth is easy to fill, serve from and clean
            Keeps cold for 7 hours and hot for 5 hours; stay cool exterior
            10 ounce capacity; hand washing is recommended`,
      extras: [
        "THERMOS vacuum insulation technology for maximum temperature retention, hot or cold",
        "Durable stainless steel interior and exterior",
        "Wide mouth is easy to fill, serve from and clean",
        "Keeps cold for 7 hours and hot for 5 hours; stay cool exterior",
        "10 ounce capacity; hand washing is recommended"
      ],
      platform:"Thermos",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img9
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "10fwpbwj"
    },
    fields: {
      name: "DualShock 4 Wireless Controller for PlayStation 4 - Magma Red",
      slug: "dualshock-wireless",
      type: "video-games",
      price: 64.99,
      rating:4,
      discount:0,
      shippingCost:18,
      bestSeller: true,
      reviewsCount:"33,12",
      featured: false,
      quantity: 1,
      subArray: "videoGames",
      description:
        `details`,
      extras: [
        "The feel, shape, and sensitivity of the dual analog sticks and trigger buttons have been improved to provide a greater sense of control, no matter what you play",
        "The new multi touch and clickable touch pad on the face of the DualShock 4 Wireless Controller opens up worlds of new gameplay possibilities for both newcomers and veteran gamers",
        "The DualShock 4 Wireless Controller features a built in speaker and stereo headset jack, putting several new audio options in the player's hands",
        "The Dualshock 4 wireless controller can be easily recharged by plugging it into your PlayStation 4 system, even when in rest mode, or with any standard charger using a USB cable (type A to micro B sold separately)",
      ],
      platform:"Dualshock",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img10
            }
          }
        },
        {
          fields: {
            file: {
              url:  magmaImg1
            }
          }
        },
        {
          fields: {
            file: {
              url:  magmaImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: magmaImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: magmaImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "hs03efu3h0f"
    },
    fields: {
      name: "Ring Fit Adventure - Nintendo Switch",
      slug: "dualshock-wireless",
      type: "video-games",
      price: 91.00,
      rating:5,
      discount:0,
      shippingCost:0,
      bestSeller: false,
      reviewsCount:"8,121",
      featured: false,
      quantity: 1,
      subArray: "videoGames",
      description:
        `details`,
      extras: [
        "An adventure game that’s also a workout ",
        "Explore a huge fantasy world and defeat enemies using real-life exercise ",
        "Jog, sprint, and high knee through dozens of levels ",
        "Control in-game movements with the new Ring-Con and Leg Strap accessories",
        "Learn about all the great new features, including a new voice option and a fun new Rhythm Game mode that are included in the latest free update"
      ],
      platform: "Nintendo Switch",
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img11
            }
          }
        },
        {
          fields: {
            file: {
              url: adventureimg1
            }
          }
        },
        {
          fields: {
            file: {
              url: adventureimg2
            }
          }
        },
        {
          fields: {
            file: {
              url: adventureimg3
            }
          }
        },
        {
          fields: {
            file: {
              url: adventureimg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "hoihsfoig9i"
    },
    fields: {
      name: "Super Mario Party",
      slug: "dualshock-wireless",
      type: "video-games",
      price: 44.89,
      rating:4,
      discount:0,
      shippingCost:14.35,
      bestSeller: false,
      reviewsCount:"107,651",
      featured: false,
      platform: "Nintendo Switch",
      quantity: 1,
      subArray: "videoGames",
      description:
        `details`,
      extras: [
        "Outwit friends and family as you race across the board; whoever gets the most stars wins! ",
        "The original 4-player Mario Party series board game mode is back! ",
        "Character-specific Dice Blocks with alternate numberings add another level to your strategy ",
        "Pair two Nintendo Switch systems, lay them flat, and creatively combine both screens to enjoy a new, interactive style of tabletop gaming in Toad’s Rec Room mode** ",
        "80 new minigames packed with wildly different challenges and clever uses of Joy-Con controllers; Put your skills to the test in sets of five minigames online*—a series first! "
      ],
      cart: false,
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img12
            }
          }
        },
        {
          fields: {
            file: {
              url: marioImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: marioImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: marioImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: marioImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "vlondnodfe39"
    },
    fields: {
      name: "COSORI Air Fryer,Max XL 5.8 Quart,1700-Watt Electric Hot Air Fryers Oven & Oilless Cooker for Roasting,LED Digital Touchscreen with 11 Presets,Nonstick Basket,ETL Listed(100 Recipes) ",
      slug: "dualshock-wireless",
      type: "kitchen",
      price: 107.98,
      rating:3,
      discount:119.99,
      shippingCost:14.35,
      bestSeller: false,
      reviewsCount:"12,121",
      featured: false,
      platform: "COSORI",
      quantity: 1,
      subArray: "kitchen",
      description:
        `details`,
      extras: [
        "Award-Winning Design: Winner of the Red Dot Award for best design, the CP158-AF was designed in California and features an angled display with easy-to-use presets. In addition, the air fryer's compact size allows it to easily fit on your counter",
        "Less Fat: The air fryer uses up to 85% less fat than traditionally deep-fried food while maintaining the same delicious taste, making it the perfect gift for family or friends ",
        "Compared with a 4-quart round basket or even smaller one, COSORI air fryer's 5.8- Quart Square Nonstick Basket can fit a 5 lbs-6 lbs whole chicken, while a small round basket can't. Buy this XL 5.8-Quart size, serves your family with at least 3-5 people",
        "11 One-Touch Presets: Steak, Poultry, Seafood, Shrimp, Bacon, Frozen Foods, French Fries, Vegetables, Root Vegetables, Bread, and Desserts. Just choose your preset with 1 easy tap on the display and you're ready to cook. You can also set cooking temp/time ",
        "Comes with 100 original, delicious & easy recipes for every meal. Find out how our numerous influencers cook their food with COSORI air fryer in social media, also constant recipes and videos tutorials from our community ",
        "Cooking time is faster than a conventional oven, but with crispier and tastier results. It also has a shake reminder function. Preheat the unit before adding your ingredients to achieve the best results. ETL Listed, 170°F-400°F, 120V, 1700W ",
        "Helpful Service: Your purchase comes with assistance from our helpful Southern California based Customer Support Team. Please note that 120V only applies to the USA and Canada "
      ],
      cart: false,
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img13
            }
          }
        },
        {
          fields: {
            file: {
              url: cosoriImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: cosoriImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: cosoriImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: cosoriImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "vjfij9ofijosjfo"
    },
    fields: {
      name: "Rubbermaid Brilliance Pantry Organization & Food Storage Containers with Airtight Lids, Set of 10 (20 Pieces Total)",
      slug: "dualshock-wireless",
      type: "kitchen",
      price: 40.58,
      rating:3,
      discount:59.99,
      shippingCost:139.35,
      bestSeller: true,
      reviewsCount:"12,121",
      featured: false,
      platform: "Rubbermaid",
      quantity: 1,
      subArray: "kitchen",
      description:
        `details`,
      extras: [
        "Rubbermaid Modular Food Storage Containers can hold pasta, baking ingredients, or other pantry staples; save space and keep pantry organized ",
        " Great for pet food; easy to clean and scoop food from, and tight lids keep out moisture and humidity Lids snap tight to help keep food fresh ",
        "Containers stack for compact storage ",
        "Thick, durable container walls for everyday use ",
        "Freezer-safe, top-rack dishwasher-safe, and BPA-free",
        "Set of 10 food storage containers includes one 19.9-cup, one 16-cup, one 12-cup, one 8.1-cup, one 7.8-cup, one 6.6-cup, one 3.2-cup, one 1.3-cup, and two 0.5 cup mini containers, plus lids, for a total of 20 pieces "
      ],
      cart: false,
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img14
            }
          }
        },
        {
          fields: {
            file: {
              url: rubbermaidImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: rubbermaidImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: rubbermaidImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: rubbermaidImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "hoihy9oy90y0"
    },
    fields: {
      name: "Vitamix A3500 Ascent Series Smart Blender, Professional-Grade, 64 oz. Low-Profile Container, Graphite",
      slug: "dualshock-wireless",
      type: "kitchen",
      price: 599.95,
      rating:3,
      discount:699.95,
      shippingCost:656.80,
      bestSeller: true,
      reviewsCount:"12,121",
      featured: false,
      platform: "Vitamix",
      quantity: 1,
      subArray: "kitchen",
      description:
        `details`,
      extras: [
        "Program Settings: Five program settings (for Smoothies, Hot Soups, Dips & Spreads, Frozen Desserts, and Self-Cleaning) ensure walk-away convenience and consistent results. The A3500 pairs with the Vitamix Perfect Blend App: Unlock the Ascent Series A3500's full potential with 17 programs and 500+ recipes with the iOS + Android app. ",
        "Touchscreen Controls give the machine a sleek silhouette and are easily wiped clean.Electrical Ratings - 120 V, 50-60 Hz, 12 Amps. Cord: 4 feet. HP: 2.2-peak ",
        "You're in Control: Variable Speed Control and Pulse feature let you manually fine-tune the texture of any recipe ",
        "Built-In Wireless Connectivity: The motor base is able to read the container size you’ve chosen and automatically adjust program settings and maximum blending times accordingly. Add a range of compatible container sizes, building a customized blending system designed to fit your needs. ",
        "Programmable Timer: A built-in timer helps avoid over- or under-processing your custom recipes. Set the timer to the length of your blend, and it will turn the machine off automatically. What's in the Box: motor base, low-profile 64 oz. container, low-profile classic tamper, Simply Blending Cookbook"
      ],
      cart: false,
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img15
            }
          }
        },
        {
          fields: {
            file: {
              url: vitmixImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: vitmixImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: vitmixImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: vitmixImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "hfioheo9k0ef"
    },
    fields: {
      name: "New Apple MacBook Pro (16-inch, 16GB RAM, 512GB Storage, 2.6GHz Intel Core i7) - Space Gray",
      slug: "dualshock-wireless",
      type: "tech",
      price: 2149.00,
      rating:4,
      discount:2399.00,
      shippingCost:956.80,
      bestSeller: true,
      reviewsCount:"1,121",
      featured: false,
      platform: "Apple",
      quantity: 1,
      subArray: "tech",
      description:
        `details`,
      extras: [
        "Ninth-generation 6-Core Intel Core i7 Processor ",
        "Stunning 16-inch Retina Display with True Tone technology",
        "Touch Bar and Touch ID ",
        "AMD Radeon Pro 5300M Graphics with GDDR6 memory ",
        "Ultrafast SSD ",
        "Intel UHD Graphics 630 ",
        "Six-speaker system with force-cancelling woofers "
      ],
      cart: false,
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img16
            }
          }
        },
        {
          fields: {
            file: {
              url: macImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: macImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: macImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: macImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "f290023903uur"
    },
    fields: {
      name: "Mens Watches Chronograph Stainless Steel Waterproof Date Analog Quartz Fashion Business Wrist Watches for Men ",
      slug: "dualshock-wireless",
      type: "watches",
      price: 32.00,
      rating:5,
      discount:42.99,
      shippingCost:38.99,
      bestSeller: false,
      reviewsCount:"886",
      featured: false,
      platform: "BIDEN",
      quantity: 1,
      subArray: "watches",
      description:
        `details`,
      extras: [
        "★mens watches Perfect gift★: This versatile watch blend goes with every occasion be it formal or casual. Wear this watch on the go, from business, leisure to indoor and outdoor activities or for daily use. The BIDEN wrist watch is a perfect gift for you and your loved ones. ",
        "★Multifunction Design★: Three multifunction sub-dials support stopwatch and date calendar, rotatable bezel,Japanese quartz movement and battery provide accurate time keeping.The watch can be used for more than 1-3 years.",
        "★Stainless Steel Band★: Durable and comfortable stainless steel band fits to daily wear.IP plating watch case and watch band will never fade.stainless steel watch is equipped with a link remover ",
        "★3atm Daily Waterproof★Daily life waterproof, can bear sweat, accidental rain or water splash, but Not suitable for bathing, swimming, diving and so on. ",
        "★Purchase without Worry★ If you have problems during use of the wristwatch, please don't hesitate to contact us. We will offer you professional service ",
      ],
      cart: false,
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img17
            }
          }
        },
        {
          fields: {
            file: {
              url: bidenImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: bidenImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: bidenImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: bidenImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "490uslojoj00"
    },
    fields: {
      name: "Samsung Galaxy Watch (46mm, GPS, Bluetooth) – Silver",
      slug: "dualshock-wireless",
      type: "watches",
      price: 239.00,
      rating:5,
      discount:279.99,
      shippingCost:121.88,
      bestSeller: true,
      reviewsCount:"44,460",
      featured: false,
      platform: "Samsung Electronics",
      quantity: 1,
      subArray: "watches",
      description:
        `details`,
      extras: [
        "Live a stronger, smarter life with Galaxy Watch at your wrist. Rest well and stay active with built-in health tracking and a Bluetooth connection that keeps everything at your wrist. Plus, go for days without charging.",
        "Go nonstop for days on a single charge. The wireless charger lets you power up without slowing down. (Average expected performance based on typical use. Results may vary.) ",
        "Available in two sizes and three colors, the Galaxy Watch offers stylish watch faces so realistic they hardly look digital. Plus, choose from a collection of interchangeable bands.",
        "Pairs with both Android and iOS smartphones via Bluetooth connection. ",
        "Included in box: Galaxy Watch, Additional Strap (Large and Small included), Wireless charging Dock, Travel Adaptor, Quick Start Guide, User Manual (Warranty: 1 Year Standard Parts and Labor) ",
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img18
            }
          }
        },
        {
          fields: {
            file: {
              url: samWatchImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: samWatchImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: samWatchImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: samWatchImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "jijppuu80vy9y"
    },
    fields: {
      name: "Fossil Men's Coachman Quartz Stainless Steel and Leather Casual Cuff Watch ",
      slug: "dualshock-wireless",
      type: "watches",
      price: 74.00,
      rating:5,
      discount:139.00,
      shippingCost:54.75,
      bestSeller: true,
      reviewsCount:"4,460",
      featured: false,
      platform: "Fossil",
      quantity: 1,
      subArray: "watches",
      description:
        `details`,
      extras: [
        "Live a stronger, smarter life with Galaxy Watch at your wrist. Rest well and stay active with built-in health tracking and a Bluetooth connection that keeps everything at your wrist. Plus, go for days without charging.Case size: 45mm; Band size: 22mm; quartz movement with 3-hand analog display; mineral crystal face; imported ",
        "Stainless steel case with black dial and date window ",
        "Genuine brown leather band with stud detail and buckle closure; interchangeable with all Fossil 22mm bands ",
        "Multifunction watch with stopwatch functionality; three separate dials to track hours, minutes and seconds; timer; date window; 24 hour ",
        "Water resistant to 330 feet (100 M): suitable for bathing, swimming or snorkeling, but is not resistant enough to withstand scuba diving ",
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img19
            }
          }
        },
        {
          fields: {
            file: {
              url: fossilImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: fossilImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: fossilImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: fossilImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "9u90b9oobo"
    },
    fields: {
      name: "Michael Kors Lexington Chronograph Stainless Steel Watch",
      slug: "dualshock-wireless",
      type: "watches",
      price: 139.00,
      rating:2,
      discount:275.00,
      shippingCost:111.47,
      bestSeller: false,
      reviewsCount:"4,460",
      featured: false,
      platform: "Michael Kors",
      quantity: 1,
      subArray: "watches",
      description:
        `details`,
      extras: [
        "Two-tone stainless steel watch with coin-edge bezel featuring silver-tone dial featuring three subdials and date window between four and five o'clock ",
        "44 mm stainless steel case with mineral dial window",
        "Quartz movement with analog display ",
        "Stainless steel band with fold-over clasp with double push-button safety ",
        "Water resistant to 100 m (330 ft): In general, suitable for swimming and snorkeling, but not scuba diving ",
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img20
            }
          }
        },
        {
          fields: {
            file: {
              url: korsImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: korsImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: korsImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: korsImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "pnw09003390nu"
    },
    fields: {
      name: "NIXON Time Teller A045",
      slug: "dualshock-wireless",
      type: "watches",
      price: 115.00,
      rating:4,
      discount:0,
      shippingCost:0,
      bestSeller: false,
      reviewsCount:"2,030",
      featured: false,
      platform: "NIXON",
      quantity: 1,
      subArray: "watches",
      description:
        `details`,
      extras: [
        "Imported",
        "TIME TELLER, GOLD/COBALT BLUE. The 37mm Time Teller has a 3-hand movement, applied indices and custom-molded hands. It has a 5-link stainless steel jewelry style bracelet and sliding buckle ",
        "ORIGINAL NIXON DESIGN. An all-time best-seller with an unpretentious versatile appearance, this gold + blue women’s watch is water resistant up to 100m and protects against everything from rain to surf",
        "SIMPLIFY TIME. Clean lines cut through cloudy philosophy, while its simple, high concept design keeps things precise. The Time Teller is a casual Nixon watch that stands the test of time ",
        "FUELED BY ADVENTURES. We deliver products that meet your needs in various high-stress work and play environments, whether it’s across the globe or down the street",
        "FOR A LIFE WELL LIVED. Through our dedicated teams’ perspectives, we contribute to a single unified expression: team-designed, custom-built accessories "
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img21
            }
          }
        },
        {
          fields: {
            file: {
              url: nixonImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: nixonImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: nixonImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: nixonImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "ou09un0oj9jpo"
    },
    fields: {
      name: "Men's Luxury Watches Ultra Thin Wrist Watch for Men Fashion Waterproof Analog Date Watch (Blue)",
      slug: "dualshock-wireless",
      type: "watches",
      price: 21.89,
      rating:4,
      discount:0,
      shippingCost:51.82,
      bestSeller: false,
      reviewsCount:"2,030",
      featured: false,
      platform: "BesWlz",
      quantity: 1,
      subArray: "watches",
      description:
        `details`,
      extras: [
        "Luxury Men's Watch Business Unique Design 📣 : Affordable business casual style male watch , ultra thin watch case,solid stainless steel band, high-quality mineral glass mirror,auto date,fashionable appearance, bring you back to the elegant leisure and simplicity. A perfect gift for anniversary, business gift, birthday etc. This classic simple gent's wrist watch will be greatly suitable for any occasion.",
        "Minimalist Watch Accurate Time Keeping 📣 : High quality original japanese quartz movement with analog display (provide precise time keeping, long life cycle, wear resistance, shock resistance).",
        "Waterproof Watches For Men Daily Use 📣 : Daily use waterproof, not suitable for underwater activities - such as shower, swimming, ect. Please DONOT wear this watch underwater.",
        "Solid And Durable Black Watch Band 📣 :Durable and comfortable stainless steel band or leather watch bands fits to daily wear for men. Double button butterfly clasp design,easy to lock and open.In order to enhance the stability and durability of the strap, we have adopted a higher performance process for the strap, which may cause the strap adjustment to be more difficult. We will send diy tool.Please refer to our product pagefor pictures or videos for guidance. ",
        "Man Watch After Sale Service 📣 : BesWlz Quartz Wristwatches Has 30 Days Refund Guarantee For Quality Problems And 12 Months Replacement For Quality Problems. Any Question Or Problem,please Feel Free To Contact ✉☎ Seller."
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img22
            }
          }
        },
        {
          fields: {
            file: {
              url: besImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: besImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: besImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: besImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "fsopiefb03e"
    },
    fields: {
      name: "Fossil Men's Minimalist Stainless Steel and Leather Slim Casual Quartz Watch",
      slug: "dualshock-wireless",
      type: "watches",
      price: 65.89,
      rating:1,
      discount:115.00,
      shippingCost:71.93,
      bestSeller: false,
      reviewsCount:"1,130",
      featured: false,
      platform: "Fossil",
      quantity: 1,
      subArray: "watches",
      description:
        `details`,
      extras: [
        "Imported",
        "Case size: 42mm; Band size: 22mm; quartz movement with 3-hand analog display; mineral crystal face; imported.",
        "Slim black plated stainless steel case; black dial with gold-tone hands and linear hour and minute markers.",
        "Genuine brown leather band with tonal stitching and buckle closure; interchangeable with all Fossil 22mm bands.",
        "Water resistant to 165 feet (50 M): suitable for short periods of recreational swimming and showering, but not diving or snorkeling."
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img23
            }
          }
        },
        {
          fields: {
            file: {
              url: fossil2Img1
            }
          }
        },
        {
          fields: {
            file: {
              url: fossil2Img2
            }
          }
        },
        {
          fields: {
            file: {
              url: fossil2Img3
            }
          }
        },
        {
          fields: {
            file: {
              url: fossil2Img4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "owdjo9wpwfouw"
    },
    fields: {
      name: "Elite Series 2 Controller - Black",
      slug: "dualshock-wireless",
      type: "video-games",
      price: 178.87,
      rating:5,
      discount:0,
      shippingCost:204.83,
      bestSeller: false,
      reviewsCount:"7,280",
      featured: false,
      platform: "Microsoft",
      quantity: 1,
      subArray: "videoGames",
      description:
        `details`,
      extras: [
        "Play like a pro with the all new Xbox elite wireless controller series 2 ",
        "Experience limitless customization and exclusive configuration options with the Xbox Accessories app ",
        "Tailor the controller with new interchangeable thumbstick and paddle shapes ",
        "Stay in the game for longer with upto 40 hours of rechargeable battery life. Use Xbox Wireless, Bluetooth, or the included USB C cable to play across your Xbox One and Windows 10 devices ",
        "MSRP $179.99 ",
        "Compatible with Xbox Series X, Xbox One, Windows 10 "
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img24
            }
          }
        },
        {
          fields: {
            file: {
              url: eliteImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: eliteImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: eliteImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: eliteImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "fpewu0wnw"
    },
    fields: {
      name: "Turtle Beach - Ear Force Recon 50X Stereo Gaming Headset - Xbox One",
      slug: "dualshock-wireless",
      type: "video-games",
      price: 29.95,
      rating:2,
      discount:24.95,
      shippingCost:49.67,
      bestSeller: true,
      reviewsCount:"7,280",
      featured: false,
      platform: "Turtle Beach",
      quantity: 1,
      subArray: "videoGames",
      description:
        `details`,
      extras: [
        "Crystal clear chat: An adjustable, high sensitivity mic picks up your voice loud and clear, and can be removed when watching movies or listening to music ",
        "Lightweight and comfortable: Play for hours (or days) in complete comfort ",
        "High quality 40 millimeter speakers: Hear every crisp high and thundering low with these large 40 millimeter speakers ",
        "Convenient in line controls: Convenient in line controls place master volume and mic mute right at your fingertips ",
        "Versatile compatibility: Works great with new Xbox One controller with the 3.5 millimeter jack, Xbox Series X, PS4 Pro and PS4, as well as PC, and Mac "
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img25
            }
          }
        },
        {
          fields: {
            file: {
              url: turtleImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: turtleImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: turtleImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: turtleImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "powdpdfojow"
    },
    fields: {
      name: "Ghost of Tsushima - PlayStation 4",
      slug: "dualshock-wireless",
      type: "video-games",
      price: 59.99,
      rating:5,
      discount:0,
      shippingCost:43.55,
      bestSeller: true,
      reviewsCount:"990",
      featured: false,
      platform: "PlayStation 4",
      quantity: 1,
      subArray: "videoGames",
      description:
        `details`,
      extras: [
        "In this open-world action adventure, you'll roam vast countrysides and expansive terrain to encounter rich characters, discover ancient landmarks, and uncover the hidden beauty of tsushima. ",
        "The Rise of the Ghost: in his quest to reclaim tsushima, Jin must seek support from old friends and new unlikely allies. ",
        "Challenge opponents with your katana for an immersive Samurai combat experience, master the Bow to eliminate distant threats, and develop stealth tactics to disorient and ambush enemies with surprise attacks. "
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img26
            }
          }
        },
        {
          fields: {
            file: {
              url: ghostImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: ghostImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: ghostImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: ghostImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "sf9o3uf0fnf"
    },
    fields: {
      name: "Xbox Wireless Controller - Grey-Green",
      slug: "dualshock-wireless",
      type: "video-games",
      price: 74.99,
      rating:5,
      discount:0,
      shippingCost:0,
      bestSeller: false,
      reviewsCount:"6,448",
      featured: false,
      platform: "Xbox One",
      quantity: 1,
      subArray: "videoGames",
      description:
        `details`,
      extras: [
        "Experience the enhanced comfort and feel of the Xbox wireless controller",
        "Features a light grey design with green accents ",
        "Play your favorite games on Windows 10 PCs and tablets; Plus, upto twice the wireless range (tested using the Xbox One S Console) ",
        "Stay on target with textured grip; Compatible With: Xbox One X, Xbox One S, Xbox One, Windows 10 ",
        "Includes Bluetooth technology for gaming on Windows 10 PCs and tablets "
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img27
            }
          }
        },
        {
          fields: {
            file: {
              url: xboxImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: xboxImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: xboxImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: xboxImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "fwuw0nff0uwo"
    },
    fields: {
      name: "Acer Nitro 5 Gaming Laptop, 9th Gen Intel Core i5-9300H, NVIDIA GeForce GTX 1650, 15.6",
      slug: "dualshock-wireless",
      type: "video-games",
      price: 748.00,
      rating:3,
      discount:0,
      shippingCost:156.89,
      bestSeller: true,
      reviewsCount:"998",
      featured: false,
      platform: "Acer",
      quantity: 1,
      subArray: "videoGames",
      description:
        `details`,
      extras: [
        "9th Generation Intel Core i5-9300H Processor (Up to 4.1 GHz) ",
        "15' Full HD Widescreen IPS LED-backlit display | NVIDIA GeForce GTX 1650 Graphics with 4 GB of dedicated GDDR5 VRAM",
        "8GB DDR4 2666MHz Memory | 256GB PCIe NVMe SSD (2 x PCIe M.2 slots - 1 slot open for easy upgrades) & 1 - Available hard drive bay ",
        "LAN: 10/100/1000 Gigabit Ethernet LAN (RJ-45 port) | Wireless: Intel Wireless Wi-Fi 6 AX200 802.11ax",
        "Backlit keyboard | Acer CoolBoost technology with twin fans and dual exhaust ports"
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img28
            }
          }
        },
        {
          fields: {
            file: {
              url: acerImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: acerImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: acerImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: acerImg4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "fow9ufn0wu9u9"
    },
    fields: {
      name: "De'Longhi ESAM3300 Magnifica Super Automatic Espresso & Coffee Machine",
      slug: "dualshock-wireless",
      type: "kitchen",
      price: 529.95,
      rating:3,
      discount:0,
      shippingCost:788.82,
      bestSeller: true,
      reviewsCount:"2,550",
      featured: false,
      platform: "De'Longhi",
      quantity: 1,
      subArray: "kitchen",
      description:
        `details`,
      extras: [
        "Make sure this fits by entering your model number. ",
        "Easy-to-use rotary and push button control panel with programmable menu settings and beans container capacity is 8.8 ounces. Coffee grounds container- 14 cups or after 72 hours from first use. Maximum cup height- 4.25 inches. Input power - 1350 watts ",
        "Grinds beans instantly with the patented, compact and easy-to-clean system. Use your favorite coffee beans to create your perfect espresso. Beans with less visible oil, usually a medium roast, are recommended for best grinder performance",
        "Maintenance: De’Longhi machines require half the cleaning time of other brands, unlike competitor machines, which require chemical cleaning tablets monthly. The machine does not deliver coffee, but only water is caused due to ground coffee may be blocked in the funnel. Remove the ground coffee inside the funnel, using a plastic knife. Then clean the infuser and the inside of the machine. If machine is noisy refer manual; Energy saving: With 3 hour automatic shut off "
      ],
      priceAfterAlteration: 0,
      images: [
        {
          fields: {
            file: {
              url: img29
            }
          }
        },
        {
          fields: {
            file: {
              url: longhiImg1
            }
          }
        },
        {
          fields: {
            file: {
              url: longhiImg2
            }
          }
        },
        {
          fields: {
            file: {
              url: longhiImg3
            }
          }
        },
        {
          fields: {
            file: {
              url: longhiImg4
            }
          }
        }
      ]
    }
  }
];
